module.exports = __webpack_public_path__ + "static/media/e.ee45914d.png";